import React from "react";

export default function SQLServer_SESSION_USER() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_SESSION_USER</h1>
      <p>This is the SQLServer_SESSION_USER component generated from the SQL JSON.</p>
    </div>
  );
}
